<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<h1 class="book-title"><a id="page_iv"></a>BRINGING<br/>DOWN THE<br/><span class="big1">MOB</span></h1>
<p class="linespace"> </p>
<p class="sub-title"><strong>THE WAR AGAINST<br/>THE AMERICAN MAFIA</strong></p>
<p class="linespace"> </p>
<p class="center-para">•    •    •</p>
<p class="author"><strong>Thomas A. Reppetto</strong></p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="editor">A JOHN MACRAE / HOLT PAPERBACK<br/>Henry Holt and Company New York</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?393077ba